import { Component, OnInit, Optional } from '@angular/core';
import { JedinicaGradiva } from '@app/shared/models/jedinica-gradiva';
import { ARHIV_POSJEDNIK } from '@app/shared/models/types';
import { OpenArhivWindowActionUtil } from '@app/shared/util/open-arhiv-window-util';
import { DynamicFormService } from '@ntap/common';
import {
  ActionWindowParams,
  DEFAULT_ITEM_VIEW,
  EMPTY_ACTION_RESULT,
  ItemActionResult,
  ItemUtil,
  ItemView,
  ItemViewProviderDirective,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  ViewResult,
  ViewResultListener,
  ViewState,
  ViewWindow,
  ViewWindowComponent,
  WindowRegistry
} from '@ntap/core';
import { PrimeNGButtonNewItemViewActionComponent } from '@ntap/primeng';
import { filter, first, map, Observable, switchMap } from 'rxjs';

@Component({
  selector: 'app-open-arhiv-posjednik-iz-jedinice-gradiva',
  templateUrl: './open-arhiv-posjednik-iz-jedinice-gradiva.component.html',
  providers: [
    {
      provide: ViewResultListener,
      useExisting: ViewWindowComponent
    },
    {
      provide: WindowRegistry,
      useClass: WindowRegistry
    },
    {
      provide: DynamicFormService,
      useClass: DynamicFormService
    }
  ]
})
export class OpenArhivPosjednikIzJediniceGradivaComponent
  extends PrimeNGButtonNewItemViewActionComponent
  implements OnInit
{
  static ARHIV_POSJEDNIK_VIEW_NAME = 'arhiv_posjednik_item_readonly';

  constructor(
    protected override notificationService: NotificationService,
    protected override windowRegistry: WindowRegistry,
    @Optional() protected override window: ViewWindow,
    protected listViewProvider: ListViewProviderDirective<ListView>,
    protected itemViewProvider: ItemViewProviderDirective<ItemView>
  ) {
    super(notificationService, windowRegistry, window, listViewProvider);
  }

  ngOnInit() {
    this.log('onInitCalled!');
  }

  protected override doExecuteWithItem(
    item: any
  ): Observable<ItemActionResult> {
    this.log('doExecuteWithItem' + JSON.stringify(item));
    return this.itemViewProvider.item$.pipe(
      first(),
      switchMap((item) => {
        const posjednikId = (item as JedinicaGradiva)[
          'en~jedinica_gradiva~posjednik'
        ];

        const itemm: any = {
          $itemType: ARHIV_POSJEDNIK,
          $mainType: ARHIV_POSJEDNIK,
          $parentId: posjednikId,
          $parentType: ARHIV_POSJEDNIK,
          'en~arhiv_posjednik~id': posjednikId
        };

        const itemProps =
          (posjednikId && {
            $id: posjednikId,
            $type: ARHIV_POSJEDNIK,
            $itemType: ARHIV_POSJEDNIK
          }) ||
          {};

        const keyItem = ItemUtil.extractItemKey(itemm);

        const viewState = Object.assign({}, keyItem, itemProps);

        return this.doOpenWindow(viewState).pipe(
          filter((viewResult: any) => this.acceptResult(viewResult)),
          map(
            (viewResult) =>
              new ItemActionResult(EMPTY_ACTION_RESULT, viewResult.viewData[0])
          )
        );
      })
    );
  }

  private doOpenWindow(viewState: ViewState): Observable<ViewResult> {
    return OpenArhivWindowActionUtil.open(
      this.getActionWindowParams(),
      viewState
    );
  }

  protected override getActionWindowParams(): ActionWindowParams {
    this.doSetDefaultActionViewName();
    const actionWindowParams = OpenArhivWindowActionUtil.createParams(
      this.action,
      this.windowRegistry,
      'arhiv_posjednik_item_readonly'
    );

    return actionWindowParams;
  }

  private doSetDefaultActionViewName() {
    if (!this.action.$openViewName) {
      this.action.$openViewName = DEFAULT_ITEM_VIEW;
    }
  }
}
